export default {
  listPage: {
    url: '/ec-pc-api/boom/listPage',
    type: 'post'
  },
  // //商品销量表 - 分页
  // salesPageList: {
  //   url: '/ec-pc-api/merchandise/sales/pageList',
  //   type: 'post'
  // },
  //商品销量表 - 分页
  merchandiseSearch: {
    url: '/ec-pc-api/merchandise/sales/search',
    type: 'post'
  },
  //商品销量表 - 店铺销量详情
  storeSales: {
    url: '/ec-pc-api/merchandise/sales/store/sales',
    type: 'post'
  },
  //商品销量表 - 店铺查询
  salesGetStore: { 
    url: '/ec-pc-api/merchandise/sales/getStore',
    type: 'get'
  },
  //商品销量表 - 导出
  pageListExport: { 
    url: '/ec-pc-api/merchandise/sales/pageListExport',
    type: 'post'
  },
  //产品销量查询导出
  productPageListExport: { 
    url: '/ec-pc-api/product/sales/pageListExport',
    type: 'post'
  },
  //产品销量分页查询
  salesSearch: { 
    url: '/ec-pc-api/product/sales/search',
    type: 'post'
  },
  //产品销量表 - 店铺查询
  productSalesGetStore: { 
    url: '/ec-pc-api/product/sales/getStore',
    type: 'get'
  },
  //产品销量分页查询
  productStoreSales: { 
    url: '/ec-pc-api/product/sales/store/sales',
    type: 'post'
  },
  //产品销量表导出
  productSaleDetailExport: { 
    url: '/ec-pc-api/product/sales/productSaleDetailExport',
    type: 'post'
  },
  //店铺销售金额详情
  storeSalesAmount: { 
    url: '/ec-pc-api/product/sales/store/salesAmount',
    type: 'post'
  },
  // 店铺销售额详情
  storeSaleAmount: {
    type: 'post',
    url: `/ec-pc-api/merchandise/sales/store/saleAmount`
  },
}